import React, { JSX } from 'react';

import { ApiDurationType, ApiDurationInfo } from '@ibe/api';

import styled from '../../../../../Styles/theme';
import useTranslation from '../../../../Hooks/useTranslation';

import fallback from '../../../../../_Translations/generated/duration.en.t.json';
import Keys from '../../../../../_Translations/generated/duration.en.t.json.keys';

interface Properties {
  info: ApiDurationInfo;
}

const Span = styled.span`
  white-space: nowrap;
`;

const Duration = ({ info }: Properties): JSX.Element => {
  const { t } = useTranslation('duration', fallback, Keys);
  const key = info.type === ApiDurationType.NIGHT ? Keys.night : Keys.day;

  return <Span>{t(key, { duration: info.duration, count: info.duration })}</Span>;
};

export default Duration;
